import { Tabs } from 'antd';
import styled from 'styled-components';

const TabsStyled = styled(Tabs)`
  height: 100%;
`;

TabsStyled.TabPane = Tabs.TabPane;
export default TabsStyled;
